import React from 'react';
import { ManageScheduleBatchContextProvider } from 'modals/batches/context/ManageScheduleBatchContext';
import { ManageScheduleBatchModal } from 'modals/batches/ManageScheduleBatchModal';

export const ManageScheduleBatch = () => {
  return (
    <ManageScheduleBatchContextProvider>
      <ManageScheduleBatchModal />
    </ManageScheduleBatchContextProvider>
  );
};
